import { useEffect, useState } from "react"
import BaseModal from "../../../components/layout/BaseModal"
import { useQueryClient } from "@tanstack/react-query"
import { useCreateObjectContractMutation } from "../api/services"
import BaseInputField from "../../../components/elements/BaseInputField"
import { Customer } from "../../Kunden/types/Types"
import dayjs from "dayjs"
import { Form } from "antd"

type EditOBVModalType = {
    modalId: number
    customer: Customer
    object: string
    objectId: string
    data: any // TODO
    closeModal: () => void
}

export default function EditOBVModal(props: EditOBVModalType) {
    const [price, setprice] = useState<string>()
    const [contractStart, setcontractStart] = useState<string>()

    const queryClient = useQueryClient()
    const { mutate: createObv } = useCreateObjectContractMutation(queryClient, props.modalId)
    const sendOBV = () => {
        props.closeModal()
        createObv({
            obj: props.objectId,
            cus: props.customer._id ?? "",
            contract_start: dayjs(contractStart).format() ?? String(new Date()),
            price: Number(price),
        })
    }

    const [form] = Form.useForm()
    useEffect(() => {
        form.setFieldsValue({
            objekt: props.object,
            customer:
                props.customer?.customer?.name +
                " | " +
                props.customer?.customer?.adress?.street +
                " " +
                props.customer?.customer?.adress?.nr +
                ", " +
                props.customer?.customer?.adress?.plz +
                " " +
                props.customer?.customer?.adress?.city,
        })
    }, [form, props.customer, props.data, props.object])

    return (
        <BaseModal
            size
            modalId={props.modalId}
            title="Objektbetreuungsvertrag erstellen"
            bottomRow={
                <div className="flex justify-end">
                    <button className="btn btn-primary" onClick={() => form.submit()}>
                        Abschicken
                    </button>
                </div>
            }>
            <Form form={form} onFinish={sendOBV}>
                <Form.Item name={"objekt"} className="mb-2" rules={[{ required: false }]}>
                    <BaseInputField label={"Objekt"} type={"text"} disabled onChange={() => {}} classProps="mt-2" />
                </Form.Item>

                <Form.Item name={"customer"} className="mb-2" rules={[{ required: false }]}>
                    <BaseInputField label={"Kunde"} type={"text"} disabled onChange={() => {}} />
                </Form.Item>
                <Form.Item name={"contract_start"} className="mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField label={"Vertragsbeginn"} type={"Date"} onChange={setcontractStart} />
                </Form.Item>
                <Form.Item name={"preis"} className="mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField label={"Preis"} type={"number"} onChange={setprice} placeholder="Preis eintragen" />
                </Form.Item>
            </Form>
        </BaseModal>
    )
}
